import { BaseService } from '@/core/base-service';

export default class ServiceAgreementService extends BaseService<any> {
	public constructor() {
		super('services/servicezef/api/service-agreement');
	}
}
